import {defineStore} from "pinia";
import storage from "@/utils/storage";
import router from "@/router";
import dynamic from "@/router/openTreeToArray";
import tabsStore from "@/store/modules/tabs";
import request from "@/request";
import {ElMessage} from "element-plus";


/**
 * @description: 用于用户数据
 */
const userStore = defineStore("user", {
    state: () => ({
        /**
         * token
         */
        token: storage.get("token"),
        /**
         * 用户信息
         */
        info: {},
        /**
         * 初始化路由标记
         */
        initRouter: false,
        /**
         * 路由
         */
        router: [],
        qrcRouters: [
            {
                "id": "401",
                "title": "TB代付",
                "path": "/qrc/QrcAlipayXianyu",
                "component": "qrc/QrcAlipayXianyu",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_xianyu"
            }, {
                "id": "402",
                "title": "支付宝金条",
                "path": "/qrc/QrcAlipayUid",
                "component": "qrc/QrcAlipayUid",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_uid"
            }, {
                "id": "403",
                "title": "支付宝H5",
                "path": "/qrc/QrcAlipayH5",
                "component": "qrc/QrcAlipayH5",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "query": "",
                "payType": "alipay_h5"
            }, {
                "id": "404",
                "title": "支付宝AA",
                "path": "/device/AlipayAA",
                "component": "device/AlipayAA",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_aa"
            }, {
                "id": "405",
                "title": "微信扫码",
                "path": "/qrc/QrcWXScan",
                "component": "qrc/QrcWXScan",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wx_scan"
            }, {
                "id": "406",
                "title": "闲鱼直付",
                "path": "/qrc/QrcXianYuZf",
                "component": "qrc/QrcXianYuZf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xianyu_zf"
            }, {
                "id": "407",
                "title": "支付宝收款",
                "path": "/qrc/QrcAlipayYinLian",
                "component": "qrc/QrcAlipayYinLian",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_yinlian"
            }, {
                "id": "408",
                "title": "支付宝放心充",
                "path": "/qrc/QrcAlipayFxc",
                "component": "qrc/QrcAlipayFxc",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_fxc"
            }, {
                "id": "409",
                "title": "支付宝手动回调",
                "path": "/qrc/QrcManualAlipayUid",
                "component": "qrc/QrcManualAlipayUid",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "manual_alipay_uid"
            },
            // 支付宝手动订单查询
            {
                "id": "409",
                "title": "支付宝手动订单查询",
                "path": "/orderManualAlipay",
                "component": "OrderManualAlipay",
                "type": "menu",
                "icon": "el-icon-connection",
                "visible": 1,
                "payType": "manual_alipay_uid"
            }, {
                "id": "410",
                "title": "淘宝直付",
                "path": "/qrc/QrcTaoBaoZf",
                "component": "qrc/QrcTaoBaoZf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "taobao_zf"
            }, {
                "id": "411",
                "title": "支付宝小荷包",
                "path": "/qrc/QrcAlipayXhb",
                "component": "qrc/QrcAlipayXhb",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_xhb"
            }, {
                "id": "412",
                "title": "支付宝LS",
                "path": "/qrc/QrcAlipayLs",
                "component": "qrc/QrcAlipayLs",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_ls"
            }, {
                "id": "413",
                "title": "淘宝直付-游戏",
                "path": "/qrc/QrcTaoBaoGame",
                "component": "qrc/QrcTaoBaoGame",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "taobao_game"
            }, {
                "id": "414",
                "title": "抖音",
                "path": "/qrc/QrcTK",
                "component": "qrc/QrcTK",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tk"
            }, {
                "id": "415",
                "title": "支付宝当面付",
                "path": "/qrc/QrcAlipayDMF",
                "component": "qrc/QrcAlipayDMF",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_dmf"
            }, {
                "id": "416",
                "title": "支付宝当面付-分账",
                "path": "/qrc/QrcAlipayDmfFenZhang",
                "component": "qrc/QrcAlipayDmfFenZhang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_dmf_fenzhang"
            }, {
                "id": "417",
                "title": "抖音微播",
                "path": "/qrc/QrcDouyin",
                "component": "qrc/QrcDouyin",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "douyin"
            }, {
                "id": "418",
                "title": "支付宝手机网站",
                "path": "/qrc/QrcAlipayWap",
                "component": "qrc/QrcAlipayWap",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_wap"
            }, {
                "id": "419",
                "title": "手机网站分账",
                "path": "/qrc/QrcAlipayWapFenZhang",
                "component": "qrc/QrcAlipayWapFenZhang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_wap_fenzhang"
            }, {
                "id": "420",
                "title": "完美世界",
                "path": "/qrc/QrcWanmei",
                "component": "qrc/QrcWanmei",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wanmei"
            }, {
                "id": "421",
                "title": "支付宝订单码",
                "path": "/qrc/QrcAlipayOrderPay",
                "component": "qrc/QrcAlipayOrderPay",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_order_pay"
            }, {
                "id": "422",
                "title": "TL",
                "path": "/qrc/QrcTl",
                "component": "qrc/QrcTl",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tl"
            }, {
                "id": "423",
                "title": "售货机",
                "path": "/qrc/QrcShj",
                "component": "qrc/QrcShj",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "shj"
            }, {
                "id": "424",
                "title": "礼品卡",
                "path": "/qrc/QrcLPK",
                "component": "qrc/QrcLPK",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lpk"
            }, {
                "id": "425",
                "title": "支付宝现金红包",
                "path": "/qrc/QrcAlipayRedpacket",
                "component": "qrc/QrcAlipayRedpacket",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_redpacket"
            }, {
                "id": "426",
                "title": "抖音转账",
                "path": "/qrc/QrcDouYinZhuanzhang",
                "component": "qrc/QrcDouYinZhuanzhang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "douyin_zhuanzhang"
            }, {
                "id": "427",
                "title": "支付宝AAck",
                "path": "/qrc/QrcAlipayAACK",
                "component": "qrc/QrcAlipayAACK",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_aa1"
            }, {
                "id": "428",
                "title": "交易猫",
                "path": "/qrc/QrcJYM",
                "component": "qrc/QrcJYM",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jym"
            }, {
                "id": "429",
                "title": "云创",
                "path": "/qrc/QrcYunChuang",
                "component": "qrc/QrcYunChuang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "ycys"
            }, {
                "id": "430",
                "title": "中吉",
                "path": "/qrc/QrcZhongji",
                "component": "qrc/QrcZhongji",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zj"
            }, {
                "id": "431",
                "title": "京东",
                "path": "/qrc/QrcJingdongDF",
                "component": "qrc/QrcJingdongDF",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jddf"
            }, {
                "id": "432",
                "title": "支付宝App",
                "path": "/qrc/QrcAlipayApp",
                "component": "qrc/QrcAlipayApp",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_app"
            }, {
                "id": "433",
                "title": "直付通第三方",
                "path": "/qrc/QrcZFT3rd",
                "component": "qrc/QrcZFT3rd",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zft3rd"
            }, {
                "id": "434",
                "title": "盛马售货机",
                "path": "/device/SMShj",
                "component": "device/SMShj",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "smshj"
            }, {
                "id": "435",
                "title": "代付2.0",
                "path": "/qrc/QrcBalanceDf",
                "component": "qrc/QrcBalanceDf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "balance_df"
            }, {
                "id": "436",
                "title": "巨量",
                "path": "/qrc/QrcJL",
                "component": "qrc/QrcJL",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jl"
            }, {
                "id": "437",
                "title": "京东代付码",
                "path": "/qrc/QrcJDDFM",
                "component": "qrc/QrcJDDFM",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jddfm"
            }, {
                "id": "438",
                "title": "微信手动回调",
                "path": "/qrc/QrcWXSD",
                "component": "qrc/QrcWXSD",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wx_sd"
            }, {
                "id": "439",
                "title": "dyy",
                "path": "/qrc/QrcDyyShj",
                "component": "qrc/QrcDyyShj",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "dyyshj"
            }, {
                "id": "440",
                "title": "微信协议",
                "path": "/qrc/QrcWxxy",
                "component": "qrc/QrcWxxy",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "wx_xy"
            }, {
                "id": "441",
                "title": "支付宝收款单",
                "path": "/qrc/QrcAlipaySkd",
                "component": "qrc/QrcAlipaySkd",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_skd"
            }, {
                "id": "442",
                "title": "瀑布",
                "path": "/qrc/QrcPuBu",
                "component": "qrc/QrcPuBu",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "pubu"
            }, {
                "id": "443",
                "title": "微店",
                "path": "/qrc/QrcWeiDian",
                "component": "qrc/QrcWeiDian",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "weidian"
            }, {
                "id": "444",
                "title": "微店自动产码",
                "path": "/device/WeiDian2",
                "component": "device/WeiDian2",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "weidian2"
            }, {
                "id": "445",
                "title": "微信经营收款单",
                "path": "/device/WxJyskd",
                "component": "device/WxJyskd",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jyskd"
            }, {
                "id": "446",
                "title": "经营收款单手动",
                "path": "/qrc/QrcJYSKDSD",
                "component": "qrc/QrcJYSKDSD",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jyskdsd"
            }, {
                "id": "447",
                "title": "微信群红包手动",
                "path": "/qrc/QrcWXQHBSD",
                "component": "qrc/QrcWXQHBSD",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wxqhbsd"
            }, {
                "id": "448",
                "title": "直付通",
                "path": "/qrc/QrcZFT",
                "component": "qrc/QrcZFT",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zft"
            }, {
                "id": "449",
                "title": "支付宝JS",
                "path": "/qrc/QrcJsapi",
                "component": "qrc/QrcJsapi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jsapi"
            }, {
                "id": "450",
                "title": "字店通",
                "path": "/qrc/QrcZdt",
                "component": "qrc/QrcZdt",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zdt"
            }, {
                "id": "451",
                "title": "瀑布自动",
                "path": "/qrc/QrcPuBuAuto",
                "component": "qrc/QrcPuBuAuto",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "pubu_auto"
            }, {
                "id": "452",
                "title": "顺卡",
                "path": "/qrc/QrcShunKa",
                "component": "qrc/QrcShunKa",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "shunka"
            }, {
                "id": "453",
                "title": "新TB代付2.0",
                "path": "/qrc/QrcTBDF",
                "component": "qrc/QrcTBDF",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tbdf"
            }, {
                "id": "454",
                "title": "赞付",
                "path": "/qrc/QrcZanFu",
                "component": "qrc/QrcZanFu",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zanfu"
            }, {
                "id": "455",
                "title": "汇花",
                "path": "/qrc/QrcHuiHua",
                "component": "qrc/QrcHuiHua",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "huihua"
            }, {
                "id": "456",
                "title": "众驰",
                "path": "/device/HnzShj",
                "component": "device/HnzShj",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "hnz_shj"
            }, {
                "id": "457",
                "title": "xxy",
                "path": "/qrc/QrcXyShj",
                "component": "qrc/QrcXyShj",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xyshj"
            }, {
                "id": "458",
                "title": "lx",
                "path": "/qrc/QrcLX",
                "component": "qrc/QrcLX",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lx"
            }, {
                "id": "459",
                "title": "洞窝",
                "path": "/qrc/QrcDongWo",
                "component": "qrc/QrcDongWo",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "dongwo"
            }, {
                "id": "460",
                "title": "金条金额回调",
                "path": "/qrc/QrcJinTiao",
                "component": "qrc/QrcJinTiao",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jintiao"
            }, {
                "id": "461",
                "title": "淘宝群红包",
                "path": "/device/Tbqhb",
                "component": "device/Tbqhb",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tbqhb"
            }, {
                "id": "465",
                "title": "支付宝金条小额",
                "path": "/qrc/QrcAlipayUidXiaoe",
                "component": "qrc/QrcAlipayUidXiaoe",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_uid_xiaoe"
            }, {
                "id": "466",
                "title": "支付宝金条混合",
                "path": "/qrc/QrcAlipayUidMix1",
                "component": "qrc/QrcAlipayUidMix1",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_uid_mix1"
            }, {
                "id": "467",
                "title": "支付宝金条混合小额",
                "path": "/qrc/QrcAlipayUidMix2",
                "component": "qrc/QrcAlipayUidMix2",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_uid_mix2"
            }, {
                "id": "468",
                "title": "TB代付-店铺",
                "path": "/device/AlipayXianyu",
                "component": "device/AlipayXianyu",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_xianyu"
            }, {
                "id": "469",
                "title": "TB代付-店铺(CK)",
                "path": "/device/AlipayDf",
                "component": "device/AlipayDf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_xianyu"
            }, {
                "id": "470",
                "title": "代付2.0店铺",
                "path": "/device/DevBalanceDf",
                "component": "device/DevBalanceDf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "balance_df"
            }, {
                "id": "471",
                "title": "支付宝金条(子)",
                "path": "/qrc/QrcAlipayUidSub",
                "component": "qrc/QrcAlipayUidSub",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_uid_sub"
            }, {
                "id": "472",
                "title": "自助侠",
                "path": "/qrc/QrcZiZhuXia",
                "component": "qrc/QrcZiZhuXia",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zizhuxia"
            }, {
                "id": "473",
                "title": "现金红包-新",
                "path": "/qrc/QrcXianJinHB",
                "component": "qrc/QrcXianJinHB",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xianjinhb"
            }, {
                "id": "474",
                "title": "虾米",
                "path": "/device/XiaMi",
                "component": "device/XiaMi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xiami"
            }, {
                "id": "475",
                "title": "国广直付通",
                "path": "/qrc/QrcGGZFT",
                "component": "qrc/QrcGGZFT",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "ggzft"
            }, {
                "id": "476",
                "title": "拼多多代付",
                "path": "/qrc/QrcPDDDF",
                "component": "qrc/QrcPDDDF",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "pdddf"
            }, {
                "id": "477",
                "title": "微信协议新",
                "path": "/qrc/QrcWxxy1",
                "component": "qrc/QrcWxxy1",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wx_xy1"
            }, {
                "id": "478",
                "title": "洞窝协议",
                "path": "/qrc/QrcDwxy",
                "component": "qrc/QrcDwxy",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "dwxy"
            }, {
                "id": "479",
                "title": "支付宝手机网站小额",
                "path": "/qrc/QrcAlipayWapLittle",
                "component": "qrc/QrcAlipayWapLittle",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_wap_little"
            }, {
                "id": "480",
                "title": "支付宝订单码养号",
                "path": "/qrc/QrcAlipayOrderPayLittle",
                "component": "qrc/QrcAlipayOrderPayLittle",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_order_pay_little"
            }, {
                "id": "481",
                "title": "多点",
                "path": "/qrc/QrcDuoDianPhone",
                "component": "qrc/QrcDuoDianPhone",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "duodian"
            }, {
                "id": "482",
                "title": "微信JS",
                "path": "/qrc/QrcWxJsapi",
                "component": "qrc/QrcWxJsapi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wxjsapi"
            }, {
                "id": "483",
                "title": "慧云",
                "path": "/qrc/QrcHuiYun",
                "component": "qrc/QrcHuiYun",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "huiyun"
            }, {
                "id": "484",
                "title": "天猫代付自动",
                "path": "/qrc/QrcTmdfa",
                "component": "qrc/QrcTmdfa",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tmdfa"
            }, {
                "id": "484",
                "title": "食行生鲜",
                "path": "/qrc/QrcShsx",
                "component": "qrc/QrcShsx",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "shsx"
            }, {
                "id": "485",
                "title": "交通APP",
                "path": "/qrc/QrcJtApp",
                "component": "qrc/QrcJtApp",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jtapp"
            }, {
                "id": "486",
                "title": "钉钉付款码",
                "path": "/qrc/QrcDingTalk",
                "component": "qrc/QrcDingTalk",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "dingtalk"
            }, {
                "id": "487",
                "title": "青耕商城",
                "path": "/qrc/QrcQgsc",
                "component": "qrc/QrcQgsc",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "qgsc"
            }, {
                "id": "488",
                "title": "千岛",
                "path": "/qrc/QrcQianDao",
                "component": "qrc/QrcQianDao",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "qiandao"
            }, {
                "id": "489",
                "title": "wx银行收款",
                "path": "/qrc/QrcWXJianhang",
                "component": "qrc/QrcWXJianhang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wx_jianhang"
            }, {
                "id": "490",
                "title": "网易通用",
                "path": "/qrc/QrcWangyi",
                "component": "qrc/QrcWangyi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "wangyi"
            }, {
                "id": "491",
                "title": "支付宝JS养号",
                "path": "/qrc/QrcJsapiLittle",
                "component": "qrc/QrcJsapiLittle",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "jsapi_little"
            }, {
                "id": "492",
                "title": "联想立减金",
                "path": "/qrc/QrcLianXiang",
                "component": "qrc/QrcLianXiang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lianxiang"
            }, {
                "id": "493",
                "title": "联盟",
                "path": "/qrc/QrcLianMeng",
                "component": "qrc/QrcLianMeng",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lianmeng"
            }, {
                "id": "494",
                "title": "大润发",
                "path": "/qrc/QrcDarunfa",
                "component": "qrc/QrcDarunfa",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "darunfa"
            }, {
                "id": "495",
                "title": "yz-Phone",
                "path": "/qrc/QrcYunZhi",
                "component": "qrc/QrcYunZhi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "yunzhi"
            }, {
                "id": "496",
                "title": "yz-alipay",
                "path": "/device/YZStoreGroup",
                "component": "device/YZStoreGroup",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "yunzhi"
            }, {
                "id": "498",
                "title": "yz-phone",
                "path": "/device/YZPhone",
                "component": "device/YZPhone",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "yunzhi"
            }, {
                "id": "497",
                "title": "分享App",
                "path": "/qrc/QrcFenXiang",
                "component": "qrc/QrcFenXiang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "fenxiang"
            }, {
                "id": "499",
                "title": "kv售货机",
                "path": "/device/Kivend",
                "component": "device/Kivend",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "kivend"
            }, {
                "id": "500",
                "title": "TB自动代付",
                "path": "/qrc/QrcDaifuAuto",
                "component": "qrc/QrcDaifuAuto",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "daifu_auto"
            }, {
                "id": "501",
                "title": "联盟转帐",
                "path": "/qrc/QrcLianMengZZ",
                "component": "qrc/QrcLianMengZZ",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lianmeng_zz"
            }, {
                "id": "502",
                "title": "支付宝AI支付",
                "path": "/qrc/QrcAlipayMcp",
                "component": "qrc/QrcAlipayMcp",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_mcp"
            }, {
                "id": "503",
                "title": "baiyin",
                "path": "/qrc/QrcBaiYin",
                "component": "qrc/QrcBaiYin",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "baiyin"
            }, {
                "id": "504",
                "title": "AI百宝箱",
                "path": "/qrc/QrcAiDaShang",
                "component": "qrc/QrcAiDaShang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "aidashang"
            },
            {
                "id": "505",
                "title": "成长金",
                "path": "/qrc/QrcXiaoHengBao",
                "component": "qrc/QrcXiaohebao",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xiaohebao"
            },
            {
                "id": "506",
                "title": "计全支付",
                "path": "/qrc/QrcJeepay",
                "component": "qrc/QrcJeepay",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jeepay"
            },
            {
                "id": "507",
                "title": "J直付",
                "path": "/qrc/QrcJnzf",
                "component": "qrc/QrcJnzf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jnzf"
            },
            {
                "id": "508",
                "title": "Jwx代付",
                "path": "/device/Jnwx",
                "component": "device/Jnwx",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jnwx"
            },
            {
                "id": "509",
                "title": "migeai",
                "path": "/qrc/QrcMigeai",
                "component": "qrc/QrcMigeai",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "migeai"
            },
            {
                "id": "510",
                "title": "小米",
                "path": "/qrc/QrcXiaoMi",
                "component": "qrc/QrcXiaoMi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xiaomi"
            },
            {
                "id": "511",
                "title": "云快充",
                "path": "/qrc/QrcYkc",
                "component": "qrc/QrcYkc",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "ykc"
            },
            {
                "id": "512",
                "title": "老挝管理系统",
                "path": "/qrc/QrcLao",
                "component": "qrc/QrcLao1",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "lao"
            },
            {
                "id": "513",
                "title": "资和信",
                "path": "/qrc/QrcZhx",
                "component": "qrc/QrcZhx",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zhx"
            },
            {
                "id": "514",
                "title": "xiyou",
                "path": "/qrc/QrcXiYou",
                "component": "qrc/QrcXiYou",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xiyou"
            },
            {
                "id": "515",
                "title": "10代付",
                "path": "/device/jn10df",
                "component": "device/Jn10df",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jn10df"
            },
            {
                "id": "516",
                "title": "10代付码",
                "path": "/qrc/jn10df",
                "component": "qrc/QrcJn10df",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "jn10df"
            },
            {
                "id": "517",
                "title": "xxcd",
                "path": "/qrc/xxcd",
                "component": "qrc/QrcXxcd",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xxcd"
            },
            {
                "id": "518",
                "title": "代付10",
                "path": "/qrc/df10",
                "component": "qrc/QrcDf10",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "df10"
            },
            {
                "id": "519",
                "title": "ai订阅",
                "path": "/qrc/aisub",
                "component": "qrc/QrcAisub",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "aisub"
            },
            {
                "id": "520",
                "title": "JSD0",
                "path": "/qrc/jsskd",
                "component": "qrc/QrcJsskd",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jsskd"
            },
            {
                "id": "520",
                "title": "JS新",
                "path": "/qrc/jszb",
                "component": "qrc/QrcJszb",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jszb"
            },
            {
                "id": "521",
                "title": "闲鱼直付新-店铺",
                "path": "/device/xyzf_new",
                "component": "device/Xyzf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "xyzf"
            },
            {
                "id": "522",
                "title": "闲鱼直付新",
                "path": "/qrc/xyzf",
                "component": "qrc/QrcXyzf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 0,
                "payType": "xyzf"
            },
            {
                "id": "523",
                "title": "抖音直付",
                "path": "/device/dyzf",
                "component": "device/Dyzf",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "dyzf"
            },
            {
                "id": "524",
                "title": "转转",
                "path": "/device/zhuanzhuan",
                "component": "device/ZhuanZhuan",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "zhuanzhuan"
            },
            {
                "id": "525",
                "title": "手机网站商城",
                "path": "/qrc/alipayWapMall",
                "component": "qrc/QrcAlipayWapMall",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_wap_mall"
            },
            {
                "id": "526",
                "title": "建行网站",
                "path": "/qrc/jianhangWeb",
                "component": "qrc/QrcJianhangWeb",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "jianhang_web"
            },
            {
                "id": "527",
                "title": "美嘉怡",
                "path": "/qrc/meijiayi",
                "component": "qrc/QrcMeiJiaYi",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "meijiayi"
            },
            {
                "id": "528",
                "title": "美嘉怡1",
                "path": "/qrc/meijiayi1",
                "component": "qrc/QrcMeiJiaYi1",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "meijiayi1"
            },
            {
                "id": "529",
                "title": "支付宝PC支付",
                "path": "/qrc/QrcAlipayPc",
                "component": "qrc/QrcAlipayPc",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_pc"
            },
            {
                "id": "530",
                "title": "农行",
                "path": "/qrc/QrcNonghang",
                "component": "qrc/QrcNonghang",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "nonghang"
            },
            {
                "id": "531",
                "title": "微信收付通",
                "path": "/qrc/QrcWxsft",
                "component": "qrc/QrcWxsft",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "sft"
            },
            {
                "id": "532",
                "title": "支付宝制单",
                "path": "/qrc/alipayZhidan",
                "component": "qrc/QrcAlipayZhidan",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_zhidan"
            },
            {
                "id": "533",
                "title": "TH",
                "path": "/qrc/th",
                "component": "qrc/QrcTH",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "tianhong"
            },
            {
                "id": "534",
                "title": "支付宝原生代付",
                "path": "/qrc/alipayDaifu",
                "component": "qrc/QrcAlipayDaifu",
                "type": "menu",
                "icon": "el-icon-menu",
                "visible": 1,
                "payType": "alipay_daifu"
            },
        ]
    }),
    actions: {
        /**
         * 是否有推广权限
         */
        isAgent() {
            return this.info.level === 1 || this.info.level === 2;
        },
        /**
         * @description: 保存token
         * @param token
         */
        saveToken(token) {
            storage.set("token", token);
            this.token = token;
        },
        /**
         * @description: 保存用户信息 角色以及权限数据
         * @param data
         */
        saveUserInfoRolesPermissions(data) {
            this.info = data.user;
        },
        /**
         * @description: 设置路由
         */
        setRouter(enableRouter) {
            let actRouter = [];
            this.qrcRouters.forEach(qrouter => {
                enableRouter.forEach(eroute => {
                    if (qrouter.payType === eroute.payType) {
                        actRouter.push(qrouter);
                    }
                })
            });
            this.router = [
                {
                    "id": "1",
                    "title": "首页",
                    "path": "/index",
                    "component": "Index",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-house",
                    "visible": 1,
                },
                // 推广管理
                {
                    "id": "2",
                    "title": "下级管理",
                    "path": "/agent/index1",
                    "component": "Agent",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-share",
                    "visible": 1,//this.isAgent() ? 1 : 0,
                },
                // 财务管理
                {
                    "id": "3",
                    "title": "财务管理",
                    "path": "",
                    "query": "",
                    "type": "dir",
                    "icon": "el-icon-document-remove",
                    "visible": 1,
                    children: [
                        {
                            "id": "31",
                            "title": "充值记录",
                            "path": "/recharge",
                            "component": "Recharge",
                            "query": "",
                            "type": "menu",
                            "icon": "el-icon-menu",
                            "visible": 1,
                        },
                        {
                            "id": "32",
                            "title": "提现管理",
                            "path": "/withdrawal",
                            "component": "Withdrawal",
                            "query": "",
                            "type": "menu",
                            "icon": "el-icon-menu",
                            "visible": 1,
                        },
                        {
                            "id": "33",
                            "title": "转账管理",
                            "path": "/transfer",
                            "component": "Transfer",
                            "query": "",
                            "type": "menu",
                            "icon": "el-icon-menu",
                            "visible": 1,
                        },
                    ]
                },
                {
                    "id": "40",
                    "title": "收款码管理",
                    "path": "/qrc",
                    "type": "dir",
                    "icon": "el-icon-picture",
                    "visible": 1,
                    children: actRouter
                },
                // 订单投诉
                {
                    "id": "6",
                    "title": "订单投诉",
                    "path": "/orderComplaint",
                    "component": "OrderComplaint",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-memo",
                    "visible": 1,
                },
                // 订单查询
                {
                    "id": "6",
                    "title": "订单查询",
                    "path": "/order",
                    "component": "Order",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-connection",
                    "visible": 1,
                },
                // 收益统计
                {
                    "id": "7",
                    "title": "设备收益",
                    "path": "/device/income",
                    "component": "DeviceIncome",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-pie-chart",
                    "visible": 0,
                },
                // 库存
                {
                    "id": "8",
                    "title": "库存查询",
                    "path": "/qrc/stock",
                    "component": "QrcStock",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-coin",
                    "visible": 1,
                },
                // 登录日志
                {
                    "id": "9",
                    "title": "登录日志",
                    "path": "/log/Login",
                    "component": "LogLogin",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-folder-opened",
                    "visible": 1,
                },
                {
                    "id": "10",
                    "title": "发货凭证",
                    "path": "/certificate",
                    "component": "Certificate",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-ticket",
                    "visible": 1,
                },
                {
                    "id": "11",
                    "title": "上码文档",
                    "path": "/document",
                    "component": "Documents",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-document",
                    "visible": 1,
                },
                {
                    "id": "12",
                    "title": "卡密提取",
                    "path": "/kamiExport",
                    "component": "KamiExport",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-expand",
                    "visible": 1,
                },
                {
                    "id": "20",
                    "title": "TB自动代付CK管理",
                    "path": "/AlipayCookie",
                    "component": "AlipayCookie",
                    "query": "",
                    "type": "menu",
                    "icon": "el-icon-document",
                    "visible": 0,
                },
            ];

            // 动态配置路由
            dynamic.appendDynamicRoutes(this.router);
        },
        /**
         * @description: 退出登录
         */
        async logout(remote = true) {
            try {
                if (remote) {
                    const res = await request.post("/auth/logout");
                    if (res && res.code === 0) {
                        ElMessage.success("退出登录成功");
                    } else {
                        ElMessage.warning(res?.msg || "退出接口请求失败，已清除本地登录状态");
                    }
                }
            } catch (error) {
                if (remote) {
                    ElMessage.warning("退出接口请求失败，已清除本地登录状态");
                }
            } finally {
                storage.clearAll();
                dynamic.clearDynamicRoutes();
                this.$reset();
                tabsStore().$reset();
                await router.replace("/login");
            }
        },
    }

})


export default userStore
